// import React from "react";
// import { PageTabAdv } from "../../../components";

// import LeadProfile from "./Lead/LeadProfile";

// const Leads = () => {
//   const LeadsMenus = [
//     {
//       title: "Lead Profile",
//       page: <LeadProfile />,
//       type: "main",
//     },
//   ];

//   return (
//     <div>

//     </div>
//   );
// };

// export default Leads;

import React from "react";
import { NewTab, PageTab, PageTabAdv } from "../../../components";
import LeadProfile from "./Lead/LeadProfile";
import MyLeads from "./Lead/MyLeads";
import MyTeamSummary from "./Lead/MyTeamSummary";
import DailyProduction from "./Lead/DailyProduction";
import { useModuleAccess } from "../../../hooks";
import AllLeads from "./Lead/AllLeads";
import LeadsPendingApprovals from "./Lead/LeadsPendingApprovals";
import MyLeadsPendingApprovals from "./Lead/MyLeadsPendingApprovals";

const Leads = () => {
  const LeadsMenus = [
    {
      title: "Lead Profile",
      page: <LeadProfile />,
      type: "main",
      id: "leads_leadsprofile",
    },
    {
      title: "My Leads",
      page: <MyLeads />,
      type: "main",
      id: "leads_myleads",
    },
    {
      title: "My Leads Pending Approvals",
      page: <MyLeadsPendingApprovals />,
      type: "main",
      id: "leads_myleadspendingapprovals",
    },
    {
      title: "My Team Summary",
      page: <MyTeamSummary />,
      type: "main",
      id: "leads_myteamsummary",
    },
    {
      title: "Daily Production",
      page: <DailyProduction />,
      type: "main",
      id: "leads_dailyproduction",
    },
    {
      title: "All Leads",
      page: <AllLeads />,
      type: "main",
      id: "leads_allleads",
    },
    {
      title: "Leads Pending Approvals",
      page: <LeadsPendingApprovals />,
      type: "main",
      id: "leads_pendingapprovals",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: LeadsMenus,
    parentId: "leads",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="leads"
      />
    </div>
  );
};

export default Leads;
